export default "__VITE_PUBLIC_ASSET__a6150d02__"